import { ClientFirmaLogService } from 'src/app/_services/client-firma-log.service';

export interface FirmaSubmitGuard {
  uploadDocuments?: boolean;
  firmaResultLocked?: boolean;
}

const AUTOFIRMA_CANCEL_ERROR_TYPE = 'es.gob.afirma.core.AOCancelledOperationException';

/**
 * Bloquea reentradas del callback de Autofirma mientras se procesa un resultado.
 * No usa uploadDocuments: ese flag solo protege la subida del PDF en pdfProcedimiento.
 */
export function isFirmaSubmitLocked(target: FirmaSubmitGuard): boolean {
  return !!target.firmaResultLocked;
}

export function releaseFirmaSubmitLock(target: FirmaSubmitGuard): void {
  target.firmaResultLocked = false;
  if ('uploadDocuments' in target) {
    target.uploadDocuments = false;
  }
}

export function isAutofirmaCancel(errorType?: string, errorMessage?: string): boolean {
  if (errorType === AUTOFIRMA_CANCEL_ERROR_TYPE) {
    return true;
  }
  const message = (errorMessage ?? '').toLowerCase();
  return message.includes('cancelad') || message.includes('cancel');
}

/**
 * Registra siempre el evento de telemetría (incluso si el guard bloquea el submit).
 * Debe invocarse al inicio de showErrorCallback, antes de isFirmaSubmitLocked.
 */
export function isGeneratePdfReady(data: { file?: string } | null | undefined): boolean {
  return !!data?.file;
}

export function getGeneratePdfErrorMessage(data: { message?: string; error?: string; responseError?: string } | null | undefined): string | null {
  return data?.message ?? data?.error ?? data?.responseError ?? null;
}

export function logAutofirmaError(
  log: ClientFirmaLogService,
  tramiteId: number | string | undefined,
  origen: string,
  errorType?: string,
  errorMessage?: string
): void {
  if (isAutofirmaCancel(errorType, errorMessage)) {
    log.cancelada(tramiteId, origen, errorType, errorMessage);
  } else {
    log.error(tramiteId, origen, errorType, errorMessage);
  }
}
